import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { serviceSettingsRoute } from '../route';

import { onboardingApplicationsValidateSearchSchema } from './schema/onboardingApplicationsValidateSearchSchema';

export const onboardingApplicationsRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/onboarding-applications',
	component: lazyRouteComponent(
		() => import('./OnboardingApplicationsPage'),
		'OnboardingApplicationsPage',
	),
	validateSearch: onboardingApplicationsValidateSearchSchema,
});
